export class LinkContextEntry
{
  label:string;
  link:string;
}
